import { createFormbrewClient } from "@formbrew/js";
import type { FormbrewFormController } from "@formbrew/js/dom";
import { mountFormbrewForm } from "@formbrew/js/dom";
import type { FormbrewEmbedOptions } from "./embed.types.ts";

/** Fetches and mounts a managed Formbrew form in a browser element. */
export const render = async (
  target: string | HTMLElement,
  options: FormbrewEmbedOptions,
): Promise<FormbrewFormController> => {
  const clientOptions = {
    token: options.token,
  };

  if (options.baseUrl) {
    Object.assign(clientOptions, { baseUrl: options.baseUrl });
  }

  const client = createFormbrewClient(clientOptions);

  return mountFormbrewForm(target, {
    client,
    metadata: options.metadata,
    onError: options.onError,
    onSuccess: options.onSuccess,
    signal: options.signal,
  });
};
